import { AfterViewInit, Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import {
  AutomationEventTypes,
  AutomationTypes,
  automationTypesConfig,
  UpdateAutomationsComplete,
} from '@tokeet-frontend/automations'
import { Store } from '@ngrx/store'
import {
  AutomationWizardChangeEventAction,
  AutomationWizardCloseAction,
  AutomationWizardSaveAction,
} from './automations-wizard.actions'
import { Destroyable, Toaster, untilDestroy } from '@tokeet-frontend/tv3-platform'
import { Actions, ofType } from '@ngrx/effects'
import { debounceTime } from 'rxjs/operators'
import { AmplitudeService } from '@tv3/services/amplitude.service'

@Component({
  selector: 'app-automations-wizard-dialog',
  templateUrl: './automations-wizard-dialog.component.html',
  styleUrls: ['./automations-wizard-dialog.component.scss'],
  host: {
    class: 'modal-content',
  },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AutomationsWizardDialogComponent extends Destroyable implements OnInit, AfterViewInit {
  automationTypes = AutomationTypes
  automationTypesConfig = automationTypesConfig
  automationType: AutomationTypes

  activeStep = 1

  get articleId() {
    switch (this.automationType) {
      case AutomationTypes.Device:
        return 'dBf63ksi65XEWFjGzdPGAQ'
      case AutomationTypes.Invoice:
        return 'hK74BSfXiKf6L21zu61hYf'
      case AutomationTypes.Inventory:
        return '6KbpApr7Gxv2ADXyUKQT9f'
      case AutomationTypes.SecurityDeposit:
        return 'moLUyJd2ceJe7Ntxm8N7Yz'
      case AutomationTypes.Incident:
        return 'uDjhD4aEfY1huemraBzDVp'
      case AutomationTypes.Rate:
        return '3TCGqDBwkKhQy1R3WWZxs3'
      case AutomationTypes.Review:
        return '2tnCtubuTWXDxGQgzLzDLS'
      case AutomationTypes.CreditCard:
        return 'rN5sYskAFvU8K9piHWqnmj'
      case AutomationTypes.Extra:
        return '236QCEEJMHeGAnmQHr6DdP'
      case AutomationTypes.Charge:
        return 'gGvHFAT2DLKiTHXmx3LZaW'
      case AutomationTypes.Task:
        return '184Uvm6UUMtwc81pf22rHD'
      case AutomationTypes.Expense:
        return 'bPNuziiEJCiDEJiNifRhF7'
      case AutomationTypes.Message:
        return '3U4W9t3C5CScfJwLy8svF9'
      case AutomationTypes.Booking:
        return 'roydr4oqTx3Dv5ee4UDrgx'
      case AutomationTypes.Document:
        return 'uAy13DFbSebZhtDSnogdHS'
      case AutomationTypes.Guest:
        return 'iKtp1K5za5J6EkcNFLDAeX'
      default:
        return 'moLUyJd2ceJe7Ntxm8N7Yz'
    }
  }

  constructor(
    public dialogRef: MatDialogRef<AutomationsWizardDialogComponent>,
    private store: Store<any>,
    private actions: Actions,
    private toaster: Toaster,
    @Inject(MAT_DIALOG_DATA) private data: { type?: AutomationTypes; event?: AutomationEventTypes },
    private amplitudeService: AmplitudeService
  ) {
    super()
    if (this.data.type) {
      this.onChangeAutomationType(this.data.type)
    }
  }

  ngOnInit(): void {
    this.actions.pipe(ofType(AutomationWizardCloseAction), debounceTime(100), untilDestroy(this)).subscribe(() => {
      this.close()
    })

    this.actions.pipe(ofType(UpdateAutomationsComplete), debounceTime(1000), untilDestroy(this)).subscribe(() => {
      this.toaster.success($localize`Automation updated successfully.`)
    })
  }

  ngAfterViewInit() {
    if (this.data.event) {
      this.store.dispatch(AutomationWizardChangeEventAction({ event: this.data.event }))
    }
  }

  onChangeAutomationType(automationType: AutomationTypes) {
    this.amplitudeService.logEvent('automation-wizard-select-type')
    this.automationType = automationType
    this.activeStep = 2
  }

  onPrevType() {
    this.amplitudeService.logEvent('automation-wizard-prev-type')
    let index = this.automationTypesConfig.findIndex((t) => t.type === this.automationType)
    if (index === 0) {
      this.activeStep = 1
    } else {
      index -= 1
      this.automationType = this.automationTypesConfig[index].type
    }
  }

  onNextType() {
    this.amplitudeService.logEvent('automation-wizard-next-type')
    let index = this.automationTypesConfig.findIndex((t) => t.type === this.automationType)
    index = (index + 1) % this.automationTypesConfig.length

    this.automationType = this.automationTypesConfig[index].type
  }

  close() {
    this.amplitudeService.logEvent('automation-wizard-close')
    this.dialogRef.close()
  }

  onSave() {
    this.amplitudeService.logEvent('automation-wizard-save')
    this.store.dispatch(AutomationWizardSaveAction({ closeAfterSave: false }))
  }
}
